import { Lock } from '@phosphor-icons/react';

export default Lock;
